<template>
    <div v-if="email" class="row">
        <div class="col-lg-3 col-12 mx-auto" v-for="(creditScore,index) in getCreditScores" :key="index">
            <div class="mx-auto " style="position:relative;">
                <div class="row">
                    <div class="col-12 d-flex justify-content-center">
                        <apexchart
                            class="chartScore"
                            type="donut"
                            :options="reportStore.getChartOptions(creditScore)"
                            :series="reportStore.getChartSeries(creditScore.credit_score)"
                        />
                    </div>
                </div>
                <span>
                    <h3 class="text-bold-700 mb-0 text-center currentScoreHeader" style="margin-top: -50px;">
                        {{ creditScore.credit_score }}
                    </h3>
                    <img
                        :src="reportStore.images[creditScore.credit_reporting_agency.name.toLowerCase()]"
                        alt="image"
                        width="75"
                        height="75"
                        class="d-block mx-auto"
                    />
                </span>
                <div class="d-flex justify-content-center">
                    <span class="font-small-3 mb-0" :class="reportStore.getCreditScoreDifference(index) > 0 ? 'text-primary' : 'text-warning'">
                        <template v-if="reportStore.getCreditScoreDifference(index) > 0">
                            +
                        </template>
                        {{ reportStore.getCreditScoreDifference(index) }}&nbsp;
                    </span>
                    <span  class="card-text font-small-3 mb-0 text-center" style="font-size:10px;">
                        {{ creditScore.lender_rank }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue'
import VueApexCharts from "vue3-apexcharts";
import axios from 'axios';
import { useReportStore } from '../../stores/ReportStore.js'
import { useUserStore } from '../../stores/UserStore.js'

export default {
    name: 'CreditScores',
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        clientEmail: {
            type: String,
            default: null
        }
    },
    data() {
        return {
        }
    },
    setup() {
        return {
            reportStore: useReportStore(),
            userStore: useUserStore(),
            email: ref(null),
        }
    },
    computed: {
        getCreditScores()
        {
            if (this.reportStore.reports[this.email].report.creditScores && this.reportStore.reports[this.email].report.creditScores.length > 0) {
                return this.reportStore.reports[this.email].report.creditScores;
            }
            return this.reportStore.apexchart.defaultBureau;
        }
    },
    mounted() {
        this.userStore.fetchUser();
    },
    created() {
    },
    watch: {
        'userStore.user'(value) {
            if (value != null) {
                if (!value.isBusinessUser) {
                    this.email = value.email;
                }
                else {
                    this.email = this.clientEmail;
                }
                if (!this.reportStore.reports[this.email]) {
                    this.reportStore.getReport();
                }
            }
        },
    },
    methods: {
    }
}
</script>
